import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess200109Status: 'idle',
    startProcess200109Error: undefined as any,
    loadUserParamsProcess200109Status: 'idle',
    loadUserParamsProcess200109Error: undefined as any,

    process200109List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess200109 = createAsyncThunk('process200109Slice/startProcess200109', async ({ process200109 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess200109/`,
        prepareData(process200109),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess200109Status } = getState().process200109Slice
        return startProcess200109Status !== 'pending'
    }
})

export const loadUserParamsProcess200109 = createAsyncThunk('process200109Slice/loadUserParamsProcess200109', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess200109/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess200109Status } = getState().process200109Slice
        return loadUserParamsProcess200109Status !== 'pending'
    }
})

const Process200109Slice = createSlice({
    name: 'process200109Slice',
    initialState,
    reducers: {
        resetstartProcess200109: (state) => {
            state.job = undefined
            state.startProcess200109Error = undefined
        },
        resetstartProcess200109Error: (state) => {
            state.startProcess200109Error = undefined
        },
        resetloadUserParamsProcess200109: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess200109Error = undefined
        },
        resetloadUserParamsProcess200109Error: (state) => {
            state.loadUserParamsProcess200109Error = undefined
        },
        removeFromProcess200109ListById: (state, action) => {
            state.process200109List = state.process200109List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess200109ListByIds: (state, action) => {
            state.process200109List = state.process200109List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process200109List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess200109Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process200109List = []
            state.startProcess200109Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess200109.pending, (state) => {
            state.startProcess200109Status = 'pending'
            state.startProcess200109Error = undefined
        })
        builder.addCase(startProcess200109.fulfilled, (state, action) => {
            state.startProcess200109Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess200109.rejected, (state, action) => {
            state.startProcess200109Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess200109Error = action.error.message
            } else {
                state.startProcess200109Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess200109.pending, (state) => {
            state.loadUserParamsProcess200109Status = 'pending'
            state.loadUserParamsProcess200109Error = undefined
        })
        builder.addCase(loadUserParamsProcess200109.fulfilled, (state, action) => {
            state.loadUserParamsProcess200109Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess200109.rejected, (state, action) => {
            state.loadUserParamsProcess200109Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess200109Error = action.error.message
            } else {
                state.loadUserParamsProcess200109Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess200109,
    resetstartProcess200109Error,
    resetloadUserParamsProcess200109,
    resetloadUserParamsProcess200109Error,
    removeFromProcess200109ListById,
    removeFromProcess200109ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process200109Slice.actions
export default Process200109Slice.reducer
